export default "__VITE_ASSET__2$8_kEDV__"